import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { PageNames, APINames, TabNames } from './Assets/variables';
import Layout from "./Components/Layout";
import Home from "./Pages/Home";
import Catalog from "./Pages/Catalog";
import GraphqlExplorer from "./Pages/Web API/GraphqlExplorer";
import Documentation from "./Pages/Web API/Documentation";
import ReleaseNotes from "./Pages/Web API/ReleaseNotes";
import DataDictionary from "./Pages/Web API/DataDictionary";
import BulkAPIDocumentation from "./Pages/Bulk API/Documentation";
import BulkAPIDataDictionary from "./Pages/Bulk API/DataDictionary";
import Invalid from "./Pages/Invalid";
import InstrumentBase from "./Pages/API/InstrumentBase";
import APIOverview from "./Components/APIOverview";
import APIContent from "./Components/APIContent";
import APISwagger from "./Components/APISwagger";
import APIVersionHistory from "./Components/APIVersionHistory";
import APIVersionHistoryStreamingMarketDataV3 from "./Components/APIVersionHistoryStreamingMarketDataV3";
import EntityBase from "./Pages/API/EntityBase";
import ListingBase from "./Pages/API/ListingBase";
import MarketBase from "./Pages/API/MarketBase";
import InstrumentSymbology from "./Pages/API/InstrumentSymbology";
import ListingSymbology from "./Pages/API/ListingSymbology";
import InstrumentMarkets from "./Pages/API/InstrumentMarkets";
import IndexComposition from "./Pages/API/IndexComposition";
import InstrumentClassification from "./Pages/API/InstrumentClassification";
import EntityClassification from "./Pages/API/EntityClassification";
import StreamingMarketData from "./Pages/API/StreamingMarketData";
import StreamingMarketDataV3 from "./Pages/API/StreamingMarketDataV3";
import APIDefinitionStreamingMarketDataV3 from "./Components/APIDefinitionStreamingMarketDataV3";
import APIContentStreamingMarketDataV3 from "./Components/APIContentStreamingMarketDataV3";
import APIWebsocketExplorer from "./Components/APIWebsocketExplorer";
import IntradaySnapshot from "./Pages/API/IntradaySnapshot";
import APISwaggerRedirect from "./Components/APISwaggerRedirect";
import APIDefinition from "./Components/APIDefinition";
import IntradayHistory from "./Pages/API/IntradayHistory";
import StreamingIntradayTradesWithHistory from "./Pages/API/StreamingIntradayTradesWithHistory";
import APIDefinitionStreamingIntraday from "./Components/APIDefinitionStreamingIntraday";
import EndOfDaySnapshot from "./Pages/API/EndOfDaySnapshot";
import EndOfDayHistory from "./Pages/API/EndOfDayHistory";
import FreeTextSearch from "./Pages/API/FreeTextSearch";
import Estimates from "./Pages/API/Estimates";
import Fundamentals from "./Pages/API/Fundamentals";
import CorporateActions from "./Pages/API/CorporateActions";
import APIDefinitionCorporateActions from "./Components/APIDefinitionCorporateActions";
import SwissStampDuty from "./Pages/API/SwissStampDuty";
import APIOverviewExampleEndOfDayHistory from "./Components/APIOverviewExampleEndOfDayHistory";
import CriteriaSearch from "./Pages/API/CriteriaSearch";
import APIDefinitionFixedIncomeReferenceDataExtended from "./Components/APIDefinitionFixedIncomeReferenceDataExtended";
import FixedIncomeReferenceDataExtended from "./Pages/API/FixedIncomeReferenceDataExtended";
import InstrumentDetail from "./Pages/API/InstrumentDetail";
import APIOverviewExampleInstrumentMarkets from "./Components/APIOverviewExampleInstrumentMarkets";
/* import MarketsList from "./Pages/Web API/MarketsList"; */
import DigitalAssetsRegulatoryAndTaxServices from "./Pages/API/DigitalAssetsRegulatoryAndTaxServices";
import APIDefinitionDigitalAssetsRegulatoryAndTaxServices from "./Components/APIDefinitionDigitalAssetsRegulatoryAndTaxServices";
import APIContentInstrumentDetail from "./Components/APIContentInstrumentDetail";
import APICriteria from "./Components/APICriteria";
import MarketHolidays from "./Pages/API/MarketHolidays";
import IssueCondition from "./Pages/API/IssueCondition";
import APIQueryBuilder from "./Components/APIQueryBuilder";
import APIQueryBuilderForm from "./Components/APIQueryBuilderForm";
import MifidIISuitability from "./Pages/API/MifidIISuitability";
import MifidIICostAndCharges from "./Pages/API/MifidIICostAndCharges";
/* import PDFWebAPIDocumentation, { DocumentationSections } from "./Pages/Web API/PDFWebAPIDocumentation";
import PDFBulkAPIDocumentation from "./Pages/Bulk API/PDFBulkAPIDocumentation";
import PDFHackathonDocumentation2026 from "./Pages/PDFHackathonDocumentation2026"; */

const basename = document.querySelector('base')?.getAttribute('href') ?? '/';
/* const HIDDEN_PAGE_WEB_PATH = `hidden/web`;
const HIDDEN_PAGE_BULK_PATH = `hidden/bulk`;
const HIDDEN_PAGE_HACKATHON_PATH = `hidden/hackathon`; */

export default function App() {
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        {/* These hidden pages are for creating PDF files and is only intended for local use */}
        {/* DISABLE THEM BEFORE COMMIT */}
        {/* <Route path={`${HIDDEN_PAGE_WEB_PATH}/${DocumentationSections.GettingStarted}`} element={<PDFWebAPIDocumentation />} />
        <Route path={`${HIDDEN_PAGE_WEB_PATH}/${DocumentationSections.GraphQLInterface}`} element={<PDFWebAPIDocumentation />} />
        <Route path={`${HIDDEN_PAGE_WEB_PATH}/${DocumentationSections.APIDataModel}`} element={<PDFWebAPIDocumentation />} />
        <Route path={`${HIDDEN_PAGE_WEB_PATH}/${DocumentationSections.APILimits}`} element={<PDFWebAPIDocumentation />} />
        <Route path={`${HIDDEN_PAGE_WEB_PATH}/${DocumentationSections.ErrorCodes}`} element={<PDFWebAPIDocumentation />} />
        <Route path={`${HIDDEN_PAGE_WEB_PATH}/${DocumentationSections.Troubleshooting}`} element={<PDFWebAPIDocumentation />} />
        <Route path={`${HIDDEN_PAGE_WEB_PATH}/${DocumentationSections.APIVersioning}`} element={<PDFWebAPIDocumentation />} />
        <Route path={`${HIDDEN_PAGE_BULK_PATH}/${DocumentationSections.GettingStarted}`} element={<PDFBulkAPIDocumentation />} />
        <Route path={`${HIDDEN_PAGE_HACKATHON_PATH}/2026`} element={<PDFHackathonDocumentation2026 />} /> */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to={PageNames.Home} replace />} />
          <Route path={PageNames.Home} element={<Home />} />
          <Route path={PageNames.Catalog} element={<Catalog />} />
          
            <Route path={`${PageNames.Catalog}/${APINames.instrumentBase}`} element={<InstrumentBase />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.entityBase}`} element={<EntityBase />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.listingBase}`} element={<ListingBase />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.marketBase}`} element={<MarketBase />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.instrumentSymbology}`} element={<InstrumentSymbology />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.listingSymbology}`} element={<ListingSymbology />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.instrumentMarkets}`} element={<InstrumentMarkets />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverviewExampleInstrumentMarkets />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.indexComposition}`} element={<IndexComposition />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.instrumentClassification}`} element={<InstrumentClassification />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.entityClassification}`} element={<EntityClassification />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.instrumentDetail}`} element={<InstrumentDetail />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContentInstrumentDetail />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.marketHolidays}`} element={<MarketHolidays />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.issueCondition}`} element={<IssueCondition />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.mifidIISuitability}`} element={<MifidIISuitability />}>
                <Route index element={<Navigate to={TabNames.Overview} replace />} />
                <Route path={TabNames.Overview} element={<APIOverview />} />
                <Route path={TabNames.Content} element={<APIContent />} />
                <Route path={TabNames.Swagger} element={<APISwagger />} />
                <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            {<Route path={`${PageNames.Catalog}/${APINames.mifidIICostAndCharges}`} element={<MifidIICostAndCharges />}>
                <Route index element={<Navigate to={TabNames.Overview} replace />} />
                <Route path={TabNames.Overview} element={<APIOverview />} />
                <Route path={TabNames.Content} element={<APIContent />} />
                <Route path={TabNames.Swagger} element={<APISwagger />} />
                <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>}

            <Route path={`${PageNames.Catalog}/${APINames.streamingMarketData}`} element={<StreamingMarketData />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.APIDefinition} element={<APIDefinition />} />
              <Route path={TabNames.Swagger} element={<APISwaggerRedirect />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.streamingMarketDataV3}`} element={<StreamingMarketDataV3 />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContentStreamingMarketDataV3 />} />
              <Route path={TabNames.APIDefinition} element={<APIDefinitionStreamingMarketDataV3 />} />
              <Route path={TabNames.WebsocketExplorer} element={<APIWebsocketExplorer />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistoryStreamingMarketDataV3 />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.intradaySnapshot}`} element={<IntradaySnapshot />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.intradayHistory}`} element={<IntradayHistory />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.streamingIntradayTradesWithHistory}`} element={<StreamingIntradayTradesWithHistory />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.APIDefinition} element={<APIDefinitionStreamingIntraday />} />
              <Route path={TabNames.Swagger} element={<APISwaggerRedirect />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.endOfDaySnapshot}`} element={<EndOfDaySnapshot />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.endOfDayHistory}`} element={<EndOfDayHistory />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverviewExampleEndOfDayHistory />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.freeTextSearch}`} element={<FreeTextSearch />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.criteriaSearch}`} element={<CriteriaSearch />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Criteria} element={<APICriteria />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.QueryBuilder} element={<APIQueryBuilder />}>
                <Route index element={<Navigate to={"instruments"} replace />} />
                <Route path={"instruments"} element={<APIQueryBuilderForm />} />
                <Route path={"listings"} element={<APIQueryBuilderForm />} />
              </Route>
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.estimates}`} element={<Estimates />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwaggerRedirect />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.fundamentals}`} element={<Fundamentals />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwaggerRedirect />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.swissStampDuty}`} element={<SwissStampDuty />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.Swagger} element={<APISwagger />} />
              <Route path={TabNames.VersionHistory} element={<APIVersionHistory />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.corporateActions}`} element={<CorporateActions />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.APIDefinition} element={<APIDefinitionCorporateActions />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.fixedIncomeReferenceDataExtended}`} element={<FixedIncomeReferenceDataExtended />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.APIDefinition} element={<APIDefinitionFixedIncomeReferenceDataExtended />} />
            </Route>

            <Route path={`${PageNames.Catalog}/${APINames.digitalAssetsRegulatoryAndTaxServices}`} element={<DigitalAssetsRegulatoryAndTaxServices />}>
              <Route index element={<Navigate to={TabNames.Overview} replace />} />
              <Route path={TabNames.Overview} element={<APIOverview />} />
              <Route path={TabNames.Content} element={<APIContent />} />
              <Route path={TabNames.APIDefinition} element={<APIDefinitionDigitalAssetsRegulatoryAndTaxServices />} />
            </Route>

          <Route path={PageNames.GraphQLExplorer} element={<GraphqlExplorer />} />
          <Route path={PageNames.Documentation} element={<Documentation />} />
          {/* <Route path={PageNames.MarketsList} element={<MarketsList />} /> */}
          <Route path={PageNames.ReleaseNotes} element={<ReleaseNotes />} />
          <Route path={PageNames.DataDictionary} element={<DataDictionary />} />
          <Route path={PageNames.BulkAPIDocumentation} element={<BulkAPIDocumentation />} />
          <Route path={PageNames.BulkAPIDataDictionary} element={<BulkAPIDataDictionary />} />
          <Route path="*" element={<Invalid />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}